import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Button from "../../shared/button/Btn"
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { showModal } from '../../../features/modal/modalSlice'
import { useScrollLock } from '../../../hooks/useScrollLock'
import { useLocation } from 'react-router-dom'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import PageTopTitle from '../../shared/PageTopTitle'
import { firmalarimDelete, setIsDetailOpen, setUpdatedFirmalarimData } from '../../../features/firma/FirmaSlice'
import FirmaUpdate from './FirmaUpdate'

const ModalContainer = styled.div`
     position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: 700px;
        max-height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        overflow: auto;
        .container{
            width: 100%;
            padding: 30px;
            position: relative;
            .inputs{
                margin-bottom: 25px;
                .top-title{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-md);
                    width: 75%;
                    margin: 0 auto;
                }
            }
        
            .route-row{
                display: flex;
                width: 75%;
                margin: 0 auto;
                margin-block: 15px;
                .title{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                    min-width: 250px;
                    text-decoration: underline;
                }
                .text-box{
                    display: flex;
                    flex-direction: column;
                    .route-text{
                        margin-block: 5px;
                        font-weight: var(--font-weight-md);
                        font-size: var(--font-size-sm);
                        display: flex;
                        align-items: center;
                    }
                }
            }
            .row{
                width: 75%;
                margin: 0 auto;
                display: flex;
                align-items: center;
                margin-block: 15px;
                .title{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                    width: 250px;
                }
                .text{
                    font-weight: var(--font-weight-md);
                    font-size: var(--font-size-sm);
                    display: flex;
                    align-items: center;
                }
            }
            .btn{
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 15px;
                width: 100%;
            }
        }
    }


    @media (max-width: 1150px){
        .row, .route-row{
          width: 100% !important;
          justify-content: space-between;
        }
        .top-title{
            width: 100% !important;
            font-weight: var(--font-weight-lg) !important;
            font-size: var(--font-size-sm !important);
        }
        .title{
            min-width: auto !important;
            width: auto !important;
        }
        .text, .route-text{
            font-weight: var(--font-weight-md) !important;
            font-size: var(--font-size-xs) !important;
        }
    }
    @media (max-width: 850px){
        .modal{
            width: 100% !important;
            max-height: 100vh !important;
            height: 100vh;
        }
    }
`

const FirmalarimDetayModal = () => {
  const dispatch = useDispatch()
  const {modalLocation } = useSelector(state => state.modal)
  const {selectedCompanyDetail, isDetailOpen} = useSelector(state => state.firma)
  const { lockScroll, unlockScroll } = useScrollLock();
  const location = useLocation()

  //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> {dispatch(showModal(null));}}>
        <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Firma"}/>

            {
                isDetailOpen ?
                
                <FirmaUpdate />

                :

                <div className="container" >
                    
                    <div className="inputs">
                        <p className='top-title'>Firma Bilgileri</p>
                        <div className="row">
                            <div className="title">Firma Adı / Ünvanı:</div>
                            <div className="text">{selectedCompanyDetail?.companyName}</div>
                        </div>
                        <div className="row">
                            <div className="title">Firma Telefon No:</div>
                            <div className="text">{selectedCompanyDetail.companyPhone}</div>
                        </div>
                        <div className="row">
                            <div className="title">Firma Mail Adresi:</div>
                            <div className="text">{selectedCompanyDetail.companyMail}</div>
                        </div>
                        <div className="row">
                            <div className="title">Vergi Dairesi:</div>
                            <div className="text">{selectedCompanyDetail.companyTaxOffice}</div>
                        </div> 
                        
                        <div className="row">
                        <div className="title">Vergi No:</div>
                            <div className="text">{selectedCompanyDetail.companyTaxNo}</div>
                        </div>
                        <div className="row">
                            <div className="title">Firma İl/İlçe:</div>
                            <div className="text">{selectedCompanyDetail.companyCityAndTown}</div>
                        </div>
                        <div className="row">
                            <div className="title">Firma Adresi:</div>
                            <div className="text">{selectedCompanyDetail.companyAddress}</div>
                        </div>
                    </div>
                    
                    <div className="inputs">
                        <p className='top-title'>Firma Yetkilisi</p>
                        <div className="row">
                            <div className="title">Yetkili Adı Soyadı:</div>
                            <div className="text">{selectedCompanyDetail.yetkili.officialName}</div>
                        </div>
                        <div className="row">
                            <div className="title">Yetkili Telefonu:</div>
                            <div className="text">{selectedCompanyDetail.yetkili.officialPhone}</div>
                        </div>
                        <div className="row">
                            <div className="title">Yetkili Mail Adresi:</div>
                            <div className="text">{selectedCompanyDetail.yetkili.officialMail}</div>
                        </div>
                    </div>

                    <div className="inputs">
                        <p className='top-title'>Yükleme/Boşaltma Noktaları</p>
                        {selectedCompanyDetail?.routePoints.map((item, i)=>{
                            const newIndex = i+1
                            return(
                                <div className="route-row">
                                    <div className="title">{newIndex}. Yükleme/Boşaltma Noktası</div>
                                    <div className="text-box">
                                        <div className="route-text">{item.addressName}</div>
                                        <div className="route-text">{item.address}</div>
                                        <div className="route-text">{item.cityAndTown}</div>
                                        <div className="route-text">{item.routeLocation}</div>
                                        <div className="route-text">{item.storageOfficialName}</div>
                                        <div className="route-text">{item.storageOfficialPhone}</div>
                                    </div>
                                
                                </div>
                            )
                        })}
                    </div>

                    <div className='btn'>
                        <Button handleClick={() => {dispatch(setIsDetailOpen()); dispatch(setUpdatedFirmalarimData(selectedCompanyDetail)) }} width={"150px"} color='#E85446' padding='10px' >Güncelle</Button>
                        <Button handleClick={() => {dispatch(firmalarimDelete(selectedCompanyDetail.id)); dispatch(showModal(null)) }} width={"150px"} color='#E85446' padding='10px' >Sil</Button>
                        <Button handleClick={() => dispatch(showModal(null))} bgColor='#E85446' color="#fff" width={"150px"} padding='10px'>Kapat</Button>
                    </div>
                </div>
            }

            
        </div>
    </ModalContainer>
  )
}

export default FirmalarimDetayModal